import { render, staticRenderFns } from "./AdminRestaurantsTab.vue?vue&type=template&id=ef51b7f6"
import script from "./AdminRestaurantsTab.vue?vue&type=script&lang=js"
export * from "./AdminRestaurantsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports